import styled from 'styled-components';

export const ClientSettingsDropdownListsContainerBox = styled.div<{ isOpen: boolean; isContainMultipleLists: boolean }>`
  ${({ isContainMultipleLists }) => isContainMultipleLists && `
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px 32px;
    `};

  grid-column: 1/-1;
  grid-row: 2/3;

  padding-inline: 5px;
  height: ${({ isOpen }) => isOpen ? '100%' : 0};
  overflow: hidden;
`;